import script from "./NameNumberGridColumnConfigurationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NameNumberGridColumnConfigurationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./NameNumberGridColumnConfigurationDialog.vue?vue&type=style&index=0&id=5f344c2a&lang=scss"

const __exports__ = script;

export default __exports__